import { ErrorBoundary } from '@akyga/shared-ui/ErrorBoundary';

export default ErrorBoundary;
